/**
 * The system-settings API allows the call only when one access record is both
 * a super-tenant and holds the admin page. A super-tenant membership plus the
 * page on a different org is not enough.
 */
export function hasSuperTenantAdminPage(
  tenants: ReadonlyArray<{
    type: string;
    permissions: ReadonlyArray<{ type: string; method: string; route: string }>;
  }>,
): boolean {
  return tenants.some(
    (tenant) =>
      tenant.type === "SUPER_TENANT" &&
      tenant.permissions.some(
        (permission) =>
          permission.type === "PAGE" &&
          permission.method === "GET" &&
          permission.route === "admin",
      ),
  );
}
